import React, {useEffect, useState} from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'

const Account = ({ userStore }) => {
  const [account, setAccount] = useState(userStore.account)
  const [name, setName] = useState(account?.name)
  const [accountType, setAccountType] = useState(account?.accountType)

  let nameField = null

  useEffect(() => {
    setAccount(userStore.account)
    setName(account?.name)
    setAccountType(account?.accountType)
  }, [userStore.account?.name, userStore.account?.accountType])

  useEffect(() => {
    if (nameField) nameField.focus()
  }, [])

  const save = () => {
    userStore.updateAccount(account, name, accountType)
  }

  return (
    <div className="center margin-top cbs-scope">
      <table className="center p10">
        <tbody>
          <tr>
            <th className="text-right"><Lex term="organization-name" /></th>
            <td><Input innerRef={el => { nameField = el }} defaultValue={name} onChange={el => setName(el.target.value)} /></td>
          </tr>
          <tr>
            <th className="text-right"><Lex term="organization-type" /></th>
            <td><Input type="select" defaultValue={accountType} onChange={el => setAccountType(el.target.value)}>
              <option value="business"><Lex term="business" /></option>
              <option value="team"><Lex term="team" /></option>
              <option value="personal"><Lex term="personal" /></option>
            </Input>
            </td>
          </tr>
          {(userStore.getFeature('users', 'show') || (account?.accountsUsers?.length > 1)) &&
            <tr>
              <th className="text-right"><Lex term="organization-member" plural /></th>
              <td>{account?.accountsUsers?.map((u) => {
                const firstName = u.firstName || u.nickname || ''
                const lastName = u.lastName || ''
                return firstName + ' ' + lastName + ' ' + u.email
              }).join(', ')}</td>
            </tr>}
          {(userStore.getFeature('teams', 'show') || (account?.teams?.length > 1)) &&
            <tr>
              <th className="text-right"><Lex term="organization-team" plural /></th>
              <td>{account?.teams?.map((t) => t.name)}</td>
            </tr>}
          <tr>
            <th className="text-right" />
            <td><Button onClick={() => save()} color="success"><Lex term="save" /></Button></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default withUserStore(Account)
